import { render, staticRenderFns } from "./ServiceConfigTable.vue?vue&type=template&id=12de8ad4&scoped=true&"
import script from "./ServiceConfigTable.vue?vue&type=script&lang=js&"
export * from "./ServiceConfigTable.vue?vue&type=script&lang=js&"
import style0 from "./ServiceConfigTable.vue?vue&type=style&index=0&id=12de8ad4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12de8ad4",
  null
  
)

export default component.exports